module.exports = __webpack_public_path__ + "media/packs/site/assets/images/illust_site-df2c0346bdd93444b2ad860687e5037e.png";